import { Component, OnInit } from '@angular/core';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { MessageService, TreeNode } from 'primeng/api';
import { TreeNodeTovpil } from 'src/app/shared/models/TreeNodeTovpil';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ApiService } from 'src/app/api.service';
import { AuthenticationService } from 'src/app/_services';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';


@Component({
  selector: 'app-tovpil-organitation',
  templateUrl: './tovpil-organitation.component.html',
  styleUrls: ['./tovpil-organitation.component.scss'],
  providers: [MessageService]
})
export class TovpilOrganitationComponent implements OnInit {

  token: string;
  language: string;
  typeChart: string;
  security: SecurityDocument;
  displayDetailTeam: boolean;
  loadingTeam: boolean = true;

  team: TreeNodeTovpil[];

  titleModal: string;
  selectedNode: TreeNodeTovpil;

  lbl_structure: string = "Structure_";
  lbl_int_coord_organiz_chart:string ="int_coord_organiz_chart_";

  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {

    this.route.queryParams
      .subscribe(
        params => {
          this.language = params.language;
          this.typeChart = params.type;
        });

        if(!this.typeChart){
          this.typeChart= "1";
        }

    this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');

  }

  onNodeSelect(event) {
    this.selectedNode = event.node;
    this.displayDetailTeam = true;
  }

  getTovpilTeam() {

    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let period = currentMonth < 7 ? 1 : 2;

    if (!this.language) {
      this.language = "es";
    }
    
    this.getTranslatedLabels();

    let body = {
      year: currentYear,
      period: period,
      language: this.language
    }


    this.apiService.getTovpilStructureTeam(body).then(
      data => {
        this.team = data;
       // this.loadingTeam = false;
        setTimeout(() => {
          this.loadingTeam = false;
        }, 1500);
        
      });
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 'R-0200') {
            this.getTovpilTeam();
          } else {
          }
        },
        error => {
          console.error(error);
        });

  }
  getTranslatedLabels() {
    let map = new Map();
    let region:string;
    if(this.language=='es'){
      region='MX';
    }else if(this.language=='en'){
      region='US';
    }else if(this.language=='pt'){
      region='BR';
    }
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.language,
      'region': region,
      'lstLabels': [this.lbl_structure,this.lbl_int_coord_organiz_chart]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_structure = map.get(this.lbl_structure);
        this.lbl_int_coord_organiz_chart = map.get(this.lbl_int_coord_organiz_chart);
      });
  }

}
